import { MovieMemCondition, MovieMemPurchaseCondition } from './constants';

const attributes = {

  movie_item_type: {
    friendly: 'Item Type',
    validations: {
      maxLength: 150,
    },
  },

  movie_name: {
    friendly: 'Movie',
    validations: {
      maxLength: 150,
    },
  },

  movie_celeb: {
    friendly: 'Celebrities',
    validations: {
      maxLength: 150,
    },
  },

  movie_year: {
    friendly: 'Year',
    validations: {
      type: 'integer',
      mustBePositive: true,
    },
  },

  movie_genre: {
    friendly: 'Genre',
    validations: {
      maxLength: 150,
    },
  },

  movie_studio: {
    friendly: 'Studio',
    validations: {
      maxLength: 150,
    },
  },

  movie_edition: {
    friendly: 'Edition',
    validations: {
      maxLength: 150,
    },
  },

  movie_maker: {
    friendly: 'Maker',
    validations: {
      maxLength: 255,
    },
  },

  movie_material: {
    friendly: 'Material',
    validations: {
      maxLength: 255,
    },
  },

  movie_signed: {
    friendly: 'Signed',
    validations: {
      maxLength: 255,
    },
  },

  movie_dimensions: {
    friendly: 'Dimensions',
    validations: {
      maxLength: 150,
    },
  },

  movie_weight: {
    friendly: 'Weight',
    validations: {
      maxLength: 150,
    },
  },

  movie_accessories: {
    friendly: 'Accessories',
    validations: {
      maxLength: 255,
    },
  },

  movie_country: {
    friendly: 'Country',
    validations: {
      maxLength: 150,
    },
  },

  movie_conditon: {
    friendly: 'Condition',
    validations: {
      type: 'enum',
      enumType: MovieMemCondition,
    },
  },

  movie_purchase_condition: {
    friendly: 'Purchase Condition',
    validations: {
      type: 'enum',
      enumType: MovieMemPurchaseCondition,
    },
  },

};

export default attributes;

export const MovieMemDefaultSplitAttribute = 'movie_item_type';

export const MovieMemItemSearchAttributes = [];

export const MovieMemOverviewAttributes = ['title', 'movie_item_type', 'movie_celeb', 'movie_year', 'movie_country', 'movie_conditon', 'rarity', 'market_value',
  'quantity', 'inventory_no', 'tags',
];

export const MovieMemSpecificationAttributes = ['movie_genre', 'movie_studio', 'movie_maker', 'movie_edition', 'movie_material', 'movie_signed', 
  'movie_dimensions', 'movie_weight', 'movie_accessories',
];

export const MovieMemPurchaseAttributes = ['purchase_date', 'purchase_price', 'movie_purchase_condition', 'purchase_contact', 'purchase_notes'];

export const MovieMemDetailAttributes = [];

export const MovieMemRequiredAttributes = [];

export const MovieMemDisplayAttributes = ['movie_item_type', 'movie_name', 'movie_celeb', 'movie_year', 'movie_genre', 'tags'];

export const MovieMemSliderGalleryAttributes = {
  titleKey: 'movie_item_type',
  subtitleKey: 'movie_name',
};



// WEBPACK FOOTER //
// ./src/config/movieMemorabiliaDataAttributes.js